import { useCampaignCode } from '@campaign-services/hooks/useCampaignCode'
import { type CosignContextProps } from '@cosign/components/useContextCosign'
import { Cosign } from '@cosign/Cosign'
import { useApiCampaignActivityInfo } from '@hooks-api/fortune/useApiCampaignActivityInfo'
import { AppBar } from '../../../components/AppBar/AppBar'
import { LeftHeader } from '../../../components/TheMerchantHeader'
import { intellectualLinkMap, privacypoliciesLinkMap, merchantCustomerServiceLinkMap } from './linkMaps'

export function MerchantLogin() {
  const { campaignCodeFromUrl } = useCampaignCode()
  const { destructuredData: exhibitorSettings } = useApiCampaignActivityInfo(campaignCodeFromUrl)
  const project = exhibitorSettings?.brand_codes_info[0]?.project_code
  const campaignUrl = `${window.location.origin}/merchant/${campaignCodeFromUrl}`
  const tokenLoginUrl = `${campaignUrl}/auth-processing`

  if (!project) return null
  return (
    <>
      <AppBar left={<LeftHeader projectCode={project} />} />
      <Cosign
        title="Buygather"
        projectCode={project as CosignContextProps['projectCode']}
        emailLogin={true}
        privacypoliciesLink={privacypoliciesLinkMap[project]}
        intellectualLink={intellectualLinkMap[project]}
        serverLink={merchantCustomerServiceLinkMap[project]}
        environment="merchant"
        redirectUrl={`${campaignUrl}/product-catalog`}
        fallbackUrl={`${campaignUrl}/product-catalog`}
        tokenLoginUrl={tokenLoginUrl}
        routeMap={{
          merchant: `/merchant/${campaignCodeFromUrl}/login`,
          login: '/merchant/:code/login',
          passwordRegister: '/merchant/:code/password/register',
          passwordChange: '/merchant/:code/password/change',
          passwordReset: '/merchant/:code/password/reset',
          passwordSuccess: '/merchant/:code/password/success',
          bindPhone: '/merchant/:code/bind-phone',
          editAccount: '/merchant/:code/my-account/edit-account',
        }}
        campaignCode={campaignCodeFromUrl}
      />
    </>
  )
}
